import styled from 'styled-components';

export const AirdopsHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 20px 20px;
  font-size: 17px;
  background: ${(props) => props.theme.colors.neutral100};
  color: ${(props) => props.theme.colors.neutral500};
  border-radius: 8px;
  margin-bottom: 20px;
  margin-top: 60px;
`;

export const AirdropHeaderItem = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 20%;
  justify-content: center;
  ${({ disabled }) => disabled && 'filter: grayscale(2);'};
  ${({ disabled }) => disabled && 'opacity: 0.3;'};
`;

export const KimbaDetailsHeaderItem = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  ${({ disabled }) => disabled && 'filter: grayscale(2);'};
  ${({ disabled }) => disabled && 'opacity: 0.3;'};
`;

export const BlurredValue = styled.div<{ blurred?: boolean }>`
  ${({ blurred }) => !blurred && 'filter: blur(8px);'};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const AirdropHeaderItemMobile = styled.div`
  display: flex;
  width: 20%;
  align-items: center;
  background: ${(props) => props.theme.colors.neutral100};
  color: ${(props) => props.theme.colors.neutral500};
  border-radius: 8px;
  padding: 8px;
  margin-bottom: 12px;
  width: 100%;
`;
export const AirdropItemMobile = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid rgba(220, 220, 220);
  border-radius: 8px;
  padding: 8px 10px;
  margin-bottom: 8px;
`;

export const AirdropItemBox = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 20px 0;
  span {
    color: ${(props) => props.theme.colors.primary900};
  }
`;

export const AirdropsTableBody = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.neutral50};
  box-shadow: ${({ theme }) => theme.shadows.shadowXS};
  border-radius: 8px;
  padding: 0 10px;
`;

export const DisabledIcon = styled.div<{ disabled?: boolean }>`
  ${({ disabled }) => disabled && 'filter: grayscale(2);'};
  ${({ disabled }) => disabled && 'opacity: 0.3;'};
`;
